__webpack_require__.p = "/take-note/";